(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_pagepilot_product_details"] && !Shopify.designMode) return;
  try {
    (() => {
 const media=matchMedia('(max-width:749px)');
 const layouts=new Map();
 const topChild=(node,parent)=>{while(node&&node.parentElement!==parent)node=node.parentElement;return node;};
 function update(){
  document.querySelectorAll('.furway-mobile-purchase').forEach(root=>{
   const container=root.firstElementChild?.firstElementChild;
   if(!container)return;
   root.querySelectorAll('.buy-buttons-block form').forEach(form=>{
    const qty=form.querySelector('.pp-quantity'),button=form.querySelector('button[name="add"]');
    if(!qty||!button)return;
    let group=qty.parentElement;
    while(group&&group!==form&&!group.contains(button))group=group.parentElement;
    if(!group||group===form)return;
    const q=topChild(qty,group),b=topChild(button,group);
    if(q===b)return;
    const originalStyle=getComputedStyle(button);const originalBackground=originalStyle.backgroundColor,originalInk=originalStyle.color,originalRadius=originalStyle.borderRadius;
    const needsStyle=!group.style.getPropertyValue('--furway-buy-bg');
    group.classList.add('furway-unified-buy');q.classList.add('furway-quantity-slot');b.classList.add('furway-button-slot');
    [...group.children].forEach(child=>{if(child!==q&&child!==b&&child.tagName!=='INPUT')child.classList.add('furway-other-slot');});
    if(needsStyle){group.style.setProperty('--furway-buy-bg',originalBackground);group.style.setProperty('--furway-buy-ink',originalInk);group.style.setProperty('--furway-buy-radius',originalRadius);}
   });
   let state=layouts.get(root);
   if(!state){
    const price=topChild(container.querySelector('pagepilot-product-price'),container);
    const rating=topChild(container.querySelector('pagepilot-reviews-number'),container);
    if(!price||!rating||price===rating)return;
    const priceMark=document.createComment('price-position'),ratingMark=document.createComment('rating-position');
    price.before(priceMark);rating.before(ratingMark);
    const row=document.createElement('div');row.className='furway-price-rating';
    state={price,rating,priceMark,ratingMark,row};layouts.set(root,state);
   }
   if(media.matches){
    if(!state.row.isConnected){state.ratingMark.after(state.row);state.row.append(state.price,state.rating);}
   }else if(state.row.isConnected){state.priceMark.after(state.price);state.ratingMark.after(state.rating);state.row.remove();}
  });
  for(const [root] of layouts)if(!root.isConnected)layouts.delete(root);
 }
 media.addEventListener('change',update);
 document.addEventListener('shopify:section:load',update);
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',update,{once:true});else update();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pagepilot_reviews_number"] && !Shopify.designMode) return;
  try {
    (() => {
    const scrollToReviews = (event) => {
      if (event.type === 'keydown' && !['Enter', ' '].includes(event.key)) return;
      const trigger = event.target.closest("pagepilot-reviews-number[data-furway-scroll='true'] [ref='trigger']");
      if (!trigger) return;
      const selectors = ['#judgeme_product_reviews', '.jdgm-review-widget', '.pp-reviews-section'];
      const target = selectors.map(selector => Array.from(document.querySelectorAll(selector)).find(node => node.getClientRects().length)).find(Boolean);
      if (!target) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      let offset = 16;
      document.querySelectorAll('.ed-header, .ed-announcement, .ed-header-section, sticky-header, .header-wrapper').forEach(header => {
        const rect = header.getBoundingClientRect();
        const position = getComputedStyle(header).position;
        const parentPosition = header.parentElement ? getComputedStyle(header.parentElement).position : '';
        if (rect.height && rect.top <= 100 && (['sticky', 'fixed'].includes(position) || ['sticky', 'fixed'].includes(parentPosition))) {
          offset = Math.max(offset, rect.bottom + 16);
        }
      });
      const top = Math.max(0, window.scrollY + target.getBoundingClientRect().top - offset);
      window.scrollTo({top, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
      target.focus({preventScroll: true});
    };
    document.addEventListener('click', scrollToReviews, true);
    document.addEventListener('keydown', scrollToReviews, true);
  })();
  } catch(e) { console.error(e); }
})();

})();
